import { render } from "./DataPagination.vue?vue&type=template&id=40142772&scoped=true"
import script from "./DataPagination.vue?vue&type=script&lang=js"
export * from "./DataPagination.vue?vue&type=script&lang=js"

import "./DataPagination.vue?vue&type=style&index=0&id=40142772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40142772"]])

export default __exports__